import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'

const reducers = {}
const initialState = {
	showChatPanel: false,
	timeOutInfo: {
		showTimeoutPanel: false,
		customerFullUserId: ""
	},
	unreadChatCount: 0,
    pageOrChatBox:''
}


reducers[types.TOGGLE_CHAT_PANEL] = (state, action) => {
	var showChatPanel = !state.showChatPanel
	return Object.assign({}, state, {showChatPanel, selectedAgent: ''})
}

reducers[types.CHANGE_SELECTED_AGENT] = (state, action) => {
	return Object.assign({}, state, {selectedAgent: action.payload.agentFullUserId})
}

reducers[types.SET_DASHBOARD_CHAT_COUNT] = {
	next(state = initialState, action) {
		return Object.assign({}, state, {unreadChatCount: state.unreadChatCount + 1})
	}
}
reducers[types.SET_TIMEOUT_STATUS] = (state, action) => {
	return Object.assign({}, state, {
		timeOutInfo: Object.assign({}, state.timeOutInfo, {
			showTimeoutPanel: action.payload.showTimeoutPanel,
			customerFullUserId: action.payload.customerFullUserId
		})
	})
}
reducers[types.USER_DATA_BASE] = (state, action) => {
	return Object.assign({}, state, {userDataBase: action.payload.isShow})
}

reducers[types.SESSION_REQ_TYPE] = (state, action) => {
	return Object.assign({}, state, {sessionReqShow: action.payload.type})
}
reducers[types.CUSTOMLIST_IS_SHOW] = (state, action) => {

    return Object.assign({}, state, {customListIsShow: action.payload.type})
}
reducers[types.IS_OR_NO_USER_INFO] = (state, action) => {
	return Object.assign({}, state, {isOrNoUserInfo: action.payload.isShow})
}

reducers[types.CURRENT_SESSION_INFO] = (state, action) => {
	return Object.assign({}, state, {currentCustomerInfo: action.payload.info})
}
reducers[types.SAVE_INFO_BUT] = (state, action) => {
	return Object.assign({}, state, {saveInfoBtn: action.payload.isShow})
}


reducers[types.PAGENATION_OR_CHATBOX] = {
    next(state=initialState, action) {
        return Object.assign({}, state, { pageOrChatBox: action.payload.isshow })
    }
}


export default handleActions(reducers, initialState)
